module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_vm._v("M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ADE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ICHIGAN")]), _vm._v(" W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RITERS")]), _vm._v(" S"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "serahaft"
  }, [_vm._v("G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ENERAL")]), _vm._v(" E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DITORS")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Michael Delp, Interlochen Center for the Arts")]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("M. L. Liebler, Wayne State University")]), _vm._v(" "), _c('p', {
    staticClass: "serpf"
  }, [_vm._v("A complete listing of the books in this series can be found online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.wsupress.wayne.edu",
      "target": "_blank"
    }
  }, [_vm._v("wsupress.wayne.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("© 2019 by Wayne State University Press. All rights reserved. No part of this book may be reproduced without formal permission. Manufactured in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN 978-0-8143-4645-7 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-0-8143-4646-4 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Control Number: 2018959986")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Publication of this book was made possible by a generous gift from The Meijer Foundation. This work is supported in part by an award from the Michigan Council for Arts and Cultural Affairs.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100",
      "src": "images/mcaca-logo.jpg",
      "width": "112"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Wayne State University Press")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Leonard N. Simons Building")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("4809 Woodward Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Detroit, Michigan 48201–1309")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Visit us online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.wsupress.wayne.edu",
      "target": "_blank"
    }
  }, [_vm._v("wsupress.wayne.edu")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef683d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-ridl-0005.vue
// module id = 66
// module chunks = 0